import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const OrderDeliveryLarge = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon
      name="OrderDeliveryLarge"
      {...rest}
      enclosed
      size="l"
      viewBox="0 0 48 48"
    >
      <path
        d="M28.64 18.51a4.88 4.88 0 001.88 1.16l5.26 1.75a1.5 1.5 0 00.94-2.84l-5.25-1.76a1.792 1.792 0 01-.71-.43L28 13.64a3.19 3.19 0 00-4.52 0l-5.1 5.1a3.19 3.19 0 000 4.52l4.17 4.17a.66.66 0 01.19.46V35a1.5 1.5 0 103 0v-7.11a3.65 3.65 0 00-1.06-2.58L21.37 22l5.38-5.38 1.89 1.89zM11 23a9.25 9.25 0 109.25 9.25A9.26 9.26 0 0011 23zm0 15.5A6.25 6.25 0 1111 26a6.25 6.25 0 010 12.5z"
        fill="currentColor"
      />
      <path
        d="M37 23a9.25 9.25 0 109.25 9.25A9.26 9.26 0 0037 23zm0 15.5A6.25 6.25 0 1137 26a6.25 6.25 0 010 12.5zM31.75 13a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM21.22 8.208l-8.252 8.251 2.828 2.829 8.252-8.252-2.828-2.828z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
